import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { ErrorMessage, Field, Formik, Form } from 'formik';
import CustomLoader from '../common/CustomLoader';
import CustomSelect from '../home/collections/CustomSelect';
import ParentContentCard from '../common/ParentContentCard';
import { dropdownsForSource } from '../../common/utils/data_source-util';
import { getFieldDataTypeValue } from './common/common_utils';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import CustomRadio from '../../common/ui/CustomRadio';
import AlertMessageBox from '../../common/ui/AlertMessageBox';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class AppwriteCollectionsCreate extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    selectedCollectionIndex: 0,
    fieldDatatypes: [],
    appWriteDataCollection: '',
    selectedPrimaryKey: 'id',
  };
  async componentDidMount() {
    if (this.props.location.state) {
      const { collectionIndex } = this.props.location.state;
      this.setState({ selectedCollectionIndex: collectionIndex });
    }
    const { externalDbUuid, projectId, version } = this.props.match.params;
    await this.props.actions.loadExternalDatabase({ projectId, externalDbUuid, version });
    this.setState({ appWriteDataCollection: this.props.dataConnector.externalDatabase });
  }
  checkCollectionIndex = (state) => {
    if (state) {
      if (state.collectionIndex >= 0) {
        return true;
      }
    }
    return false;
  };
  handleCollection = () => {
    const { match, location } = this.props;
    const { projectId, externalDbUuid, version } = match.params;
    if (this.checkCollectionIndex(location.state)) {
      this.props.history.push(
        `/data-connector/${version}/v/${projectId}/appwrite-edit/${externalDbUuid}`,
      );
    } else {
      const { selectedCollectionIndex, appWriteDataCollection } = this.state;
      const newArray = appWriteDataCollection.completeData['tables'];
      const totalLengh = newArray.length - 1;
      if (selectedCollectionIndex < totalLengh) {
        this.setState({ selectedCollectionIndex: selectedCollectionIndex + 1 });
      } else {
        this.props.history.push(`/collections/${version}/v/${projectId}`);
      }
    }
  };
  handleSave = async (values) => {
    const { selectedCollectionIndex, fieldDatatypes, appWriteDataCollection, selectedPrimaryKey } =
      this.state;
    const { actions, match } = this.props;
    const { completeData, setting, name } = appWriteDataCollection;
    const newArray = completeData['tables'];
    const selectedData = newArray[selectedCollectionIndex];
    const fieldData = selectedData.fields;
    const result = {};
    Object.keys(fieldData).map((fieldName, index) => {
      result[fieldName] = fieldDatatypes[fieldName]
        ? fieldDatatypes[fieldName].value
        : fieldData[fieldName];
    });

    const { projectId, externalDbUuid, version } = match.params;
    const data = {
      version,
      collectionTitle: values.collectionTitle,
      orgCollectionName: selectedData.collectionName,
      collectionName: selectedData.collectionName,
      willPersist: false,
      fields: result,
      projectId,
      databaseId: completeData['database'].id,
      collectionId: selectedData.collectionId,
      setting: setting,
      externalDatabaseId: externalDbUuid,
      selectedPrimaryKey: selectedPrimaryKey ? selectedPrimaryKey : 'id',
      name: name ? name : '',
    };

    await actions.createCollectionWithAppwrite(data);
    await actions.appwriteUpdateExternalDatabase({
      collectionTitle: values.collectionTitle,
      projectId,
      externalDbUuid,
      result,
      version,
      collectionId: selectedData.collectionId,
      selectedPrimaryKey: selectedPrimaryKey ? selectedPrimaryKey : 'id',
    });
    this.handleCollection();
  };
  handleFieldChange = (fieldName, selectedValue) => {
    const updatedResult = { ...this.state.fieldDatatypes };
    updatedResult[fieldName[0]] = selectedValue;
    this.setState({ fieldDatatypes: updatedResult });
  };
  handleRadioChange = (fieldName) => {
    this.setState({ selectedPrimaryKey: fieldName }, () => {});
  };
  showAlertMessage = () => {
    return (
      <AlertMessageBox
        type="info"
        text={`Note: If no primary key is selected below, the system will default to using the 
<strong>'id'</strong> field as the primary key for External APIs.`}
      />
    );
  };
  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />
        </CommonPageComponent>
      );
    }
    const { dataConnector } = this.props;
    const { createCollectionWithAppwritePending, loadExternalDatabasePending } = dataConnector;
    const { completeData } = this.state.appWriteDataCollection;
    const selectedCollection = completeData
      ? completeData['tables'][this.state.selectedCollectionIndex]
      : null;

    const fieldData = selectedCollection ? selectedCollection.fields : null;
    return fieldData ? (
      <CommonPageComponent>
        <ParentContentCard
          title={'Choose Collection for Create Or Skip via Appwrite'}
          icon={'collection'}
        >
          {' '}
          <Formik
            initialValues={{
              collectionTitle: selectedCollection.collectionName
                ? selectedCollection.collectionName
                : '',
            }}
            enableReinitialize={true}
          >
            {({ values, handleChange, setFieldValue }) => (
              <Form className="ml-5">
                <div className="col-md-11 col-lg-11 col-sm-12 col-xs-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Collection Name"
                      icon="text"
                      infoIcon={true}
                      infoDescription={'Supabase collection name'}
                    >
                      <Field
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Collection Name"
                        readOnly
                        value={selectedCollection.collectionName}
                      />
                    </FormFieldWithLabel>
                  </div>

                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Collection Title"
                      icon="text"
                      infoIcon={true}
                      infoDescription={'Enter name for the collection name if  you want to change'}
                    >
                      <Field
                        type="text"
                        name="collectionTitle"
                        className="form-control form-control-sm"
                        placeholder="Collection Title"
                        value={values.collectionTitle}
                        onChange={(e) => setFieldValue('collectionTitle', e.target.value)}
                      />
                      <ErrorMessage name="collectionTitle" component="p" className="text-danger" />
                    </FormFieldWithLabel>
                  </div>
                  <hr style={{ marginBottom: '20px', visibility: 'hidden' }} />
                  {this.showAlertMessage()}
                  <div className="mt-2">
                    <h5>
                      <b>Field Type Mapping</b>
                    </h5>
                  </div>
                  <div
                    className="table-responsive"
                    style={{
                      overflow: 'visible',
                      maxHeight: 'fit-content',
                      marginBottom: '10px',
                    }}
                  >
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Fields</th>
                          <th>Types</th>
                          <th style={{ width: '12%' }}>Primary Key</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Object.keys(fieldData).map((fieldName, index) => (
                          <tr key={index}>
                            <td>{fieldName}</td>
                            <td>
                              <CustomSelect
                                name={fieldName}
                                isMulti={false}
                                onChange={setFieldValue}
                                onChangeValue={this.handleFieldChange}
                                options={dropdownsForSource}
                                value={getFieldDataTypeValue(
                                  fieldName,
                                  fieldData,
                                  this.state.fieldDatatypes,
                                )}
                              />
                            </td>
                            <td style={{ width: '12%' }}>
                              <div className="form-check ml-4 pl-3">
                                <CustomRadio label="" isRadio={false}>
                                  <Field
                                    type="checkbox"
                                    name={fieldName}
                                    className="form-check-input"
                                    checked={this.state.selectedPrimaryKey === fieldName}
                                    onChange={() => this.handleRadioChange(fieldName)}
                                  />
                                </CustomRadio>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="d-flex justify-content-between">
                    <button
                      className="btn btn-outline-secondary btn-md"
                      title="Skip"
                      type="button"
                      onClick={this.handleCollection}
                    >
                      <i className="wb webconnect-times"></i> Skip & Continue
                    </button>
                    <button
                      type="button"
                      className="btn btn-theme-submit btn-md ml-3"
                      title="Save Collection"
                      onClick={() => this.handleSave(values)}
                      disabled={createCollectionWithAppwritePending}
                    >
                      <i className="wb webconnect-save-regular"></i> Save & Continue
                      <CustomLoader loading={createCollectionWithAppwritePending} />
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </ParentContentCard>
      </CommonPageComponent>
    ) : (
      <CommonPageComponent>
        <div className="text-center">
          <CustomLoader loading={loadExternalDatabasePending} size="20px" color="#303453" />
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppwriteCollectionsCreate);
